import { addEditData, getData } from '../generic';

import { cAPI } from '../../../utils/cAPI';

export const getCatalogSettings = () => dispatch => getData(dispatch, cAPI.APGetCatalogSettings);
export const editCatalogSettings = formData => dispatch => addEditData(dispatch, cAPI.APUpdateCatalogSettings, formData);
